import { render } from "./TrfWizardModuloConfiguracaoTarefas.vue?vue&type=template&id=6ff9e4b7"
import script from "./TrfWizardModuloConfiguracaoTarefas.vue?vue&type=script&lang=js"
export * from "./TrfWizardModuloConfiguracaoTarefas.vue?vue&type=script&lang=js"

import "./TrfWizardModuloConfiguracaoTarefas.vue?vue&type=style&index=0&id=6ff9e4b7&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/CadastroTarefas/components/WizardImportacaoDeTarefas/TrfWizardModuloConfiguracaoTarefas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ff9e4b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ff9e4b7', __exports__)) {
    console.log('reload')
    api.reload('6ff9e4b7', __exports__)
  }
  
  module.hot.accept("./TrfWizardModuloConfiguracaoTarefas.vue?vue&type=template&id=6ff9e4b7", () => {
    console.log('re-render')
    api.rerender('6ff9e4b7', render)
  })

}


export default __exports__